/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-left': {
    width: 18,
    height: 32,
    viewBox: '0 0 18 32',
    data: '<path pid="0" d="M15.77 32a2.11 2.11 0 01-1.43-.527l-.149-.14-13.47-13.81c-.948-.97-.961-1.972-.039-3.001l.132-.141L14.19.667c.434-.445.96-.667 1.58-.667.619 0 1.145.222 1.579.667.433.444.65.984.65 1.619a2.23 2.23 0 01-.514 1.467l-.136.152L5.55 16 17.35 28.095c.433.445.65.984.65 1.62 0 .634-.217 1.174-.65 1.618-.434.445-.96.667-1.58.667z" _fill="#000" fill-rule="nonzero"/>'
  }
})
